<template>
  <div class="act-rules">
    1、活动形式：分享您的专属链接给好友，好友通过专属链接完成注册，邀请好友数量累计达标后获得对应奖励，活动发送的总下载次数奖励为免费下载次数（非商用使用），VIP奖励为商用VIP通用优惠券、商用包季VIP、商用包年VIP。<br>
    2、被邀请人需为潮国创意新用户，被邀请人注册成功后，您获得对应奖励自动到账。<br>
    3、获得免费下载次数未使用完时，如已购买VIP会员，将优先享受VIP下载权益。拉新获得的免费下载次数无有效期限制。获得商用VIP通用优惠券自动到账，商用VIP任意档位可使用，有效期为48小时，可在支付中心查看。获得商用包季/包年VIP后，请重新登录账号即刻生效，可在个人中心查看到期时间。<br>
    4、用户不得已任何不正当手段及舞弊行为参与本活动，如存在违规行为，潮国创意网站有权收回已发放奖励，情节严重者将封禁账号，永久取消一切活动的参与资格，并保留追究用户法律责任的权利。（违规行为包括但不限于：囤积奖品用户商业牟利、使用非法工具作弊、假冒身份、刷用户数、虚假信息等）<br>
    5、在法律法规允许范围内，活动最终解释权归潮国创意所有。如有疑问，咨询<a href="https://qiankuwang.udesk.cn/im_client/?web_plugin_id=100652&group_id=134702" target="_blank"">【在线客服】</a>
  </div>
</template>

<script>
export default {
  name: "InviteActRule"
}
</script>

<style lang="scss" scoped>
.act-rules {
  @include Position(1, 4, 50%, 63px);
  width: 1105px;
  height: 367px;
  background: #FFFFFF;
  border-radius: 20px;

  transform: translateX(-50%);
  font-size: 16px;
  font-weight: 400;
  color: #20395B;
  line-height: 30px;
  padding: 34px 50px 0 39px;
  box-sizing: border-box;
  a{
    color: $color-primary;
  }
}
</style>



<!--
  邀请活动规则 page
-->
